import { PersonalizedSearchForm } from '@keaze/web/common/interfaces';

export const DEFAULT_PERSONALIZED_SEARCH_DATA: PersonalizedSearchForm = {
  householdIncome: null,
  estimatedDeposit: null,
  address: '',
  workAddress: '',
};
